export enum EnumTipoComunicacion {
  ClienteFinal = 1,
  Mayorista = 2,
  Internas = 3
}
